import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/embr/assets/images/twitter.svg'
import _imports_1 from '@/embr/assets/images/discord.svg'
import _imports_2 from '@/embr/assets/images/medium.svg'
import _imports_3 from '@/embr/assets/images/telegram.svg'


_pushScopeId("data-v-11c5db43")
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mt-8 whitespace-pre-line" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-8 mb-4" }, "Project Links", -1)
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-8"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-8"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-8"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "mt-4" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Token Contract Address: ")
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Owner Address: ")
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" LBP Address: ")
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "LBP Details")
], -1)
const _hoisted_26 = { class: "lbp-review-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Start Date & Time", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "End Date & Time", -1)
const _hoisted_29 = { class: "lbp-review-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Trading Fee", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Platform Fee"),
  /*#__PURE__*/_createElementVNode("div", null, "2%")
], -1)
const _hoisted_32 = { class: "lbp-review-row" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Launch Token Initial Balance", -1)
const _hoisted_35 = { class: "items-center flex" }
const _hoisted_36 = { class: "mr-2" }
const _hoisted_37 = { class: "mr-1" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Collateral Token Initial Balance", -1)
const _hoisted_40 = { class: "items-center flex" }
const _hoisted_41 = { class: "mr-2" }
const _hoisted_42 = { class: "mr-1" }
const _hoisted_43 = { class: "lbp-review-row" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Start Weights", -1)
const _hoisted_46 = { class: "items-center flex" }
const _hoisted_47 = { class: "mr-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_49 = { class: "mr-1" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "End Weights", -1)
const _hoisted_52 = { class: "items-center flex" }
const _hoisted_53 = { class: "mr-1" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_55 = { class: "mr-1" }
const _hoisted_56 = { class: "lbp-review-row" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Current Weights", -1)
const _hoisted_59 = { class: "items-center flex" }
const _hoisted_60 = { class: "mr-1" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_62 = { class: "mr-1" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Liquidity", -1)
const _hoisted_64 = { class: "lbp-review-row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Volume", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Funds Raised", -1)
_popScopeId()

import useLge from '@/embr/lbp/composables/useLge';
import { GqlLge } from '@/embr/services/embr/embr-types';
import { FullPool } from '@/services/balancer/subgraph/types';
import BalIcon from '@/components/_global/BalIcon/BalIcon.vue';
import useWeb3 from '@/services/web3/useWeb3';
import { computed } from 'vue';
import BalCard from '@/components/_global/BalCard/BalCard.vue';
import BalAsset from '@/components/_global/BalAsset/BalAsset.vue';
import useNumbers from '@/composables/useNumbers';

type Props = {
  lge: GqlLge;
  pool: FullPool;
};


export default _defineComponent({
  props: {
    lge: { type: null, required: true },
    pool: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  lge: GqlLge;
  pool: FullPool;
}) {

const props = __props

const { appNetworkConfig } = useWeb3();
const { fNum } = useNumbers();

const {
  isBeforeStart,
  isAfterEnd,
  startDateTimeFormatted,
  endDateTimeFormatted,
  launchToken,
  collateralToken,
  poolLaunchToken,
  poolCollateralToken,
  collateralTokenPrice
} = useLge(props.lge, props.pool);

const fundsRaised = computed(
  () =>
    parseFloat(poolCollateralToken.value?.balance || '') -
    parseFloat(props.lge.collateralAmount)
);
const fundsRaisedValue = computed(
  () => fundsRaised.value * collateralTokenPrice.value
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: props.lge.bannerImageUrl,
      class: "mt-8"
    }, null, 8, _hoisted_1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.lge.description), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: props.lge.websiteUrl,
        target: "_blank",
        class: "mr-4"
      }, [
        _createVNode(BalIcon, {
          name: "globe",
          size: "xl"
        })
      ], 8, _hoisted_5),
      (props.lge.twitterUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: props.lge.twitterUrl,
            target: "_blank",
            class: "mr-4 -mt-1"
          }, _hoisted_8, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (props.lge.discordUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: props.lge.discordUrl,
            target: "_blank",
            class: "-mt-1 mr-4"
          }, _hoisted_11, 8, _hoisted_9))
        : _createCommentVNode("", true),
      (props.lge.mediumUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: props.lge.mediumUrl,
            target: "_blank",
            class: "-mt-1 mr-4"
          }, _hoisted_14, 8, _hoisted_12))
        : _createCommentVNode("", true),
      (props.lge.telegramUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            href: props.lge.telegramUrl,
            target: "_blank",
            class: "-mt-1 mr-4"
          }, _hoisted_17, 8, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("a", {
        href: 
        `${_unref(appNetworkConfig).explorer}/address/${props.lge.tokenContractAddress}`
      ,
        target: "_blank",
        class: "text-green-500"
      }, _toDisplayString(props.lge.tokenContractAddress), 9, _hoisted_20)
    ]),
    _createElementVNode("div", null, [
      _hoisted_21,
      _createElementVNode("a", {
        href: `${_unref(appNetworkConfig).explorer}/address/${props.lge.adminAddress}`,
        target: "_blank",
        class: "text-green-500"
      }, _toDisplayString(props.lge.adminAddress), 9, _hoisted_22)
    ]),
    _createElementVNode("div", null, [
      _hoisted_23,
      _createElementVNode("a", {
        href: `${_unref(appNetworkConfig).explorer}/address/${props.lge.address}`,
        target: "_blank",
        class: "text-green-500"
      }, _toDisplayString(props.lge.address), 9, _hoisted_24),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", null, [
          _hoisted_27,
          _createElementVNode("div", null, _toDisplayString(props.lge.startDate), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_28,
          _createElementVNode("div", null, _toDisplayString(props.lge.endDate), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", null, [
          _hoisted_30,
          _createElementVNode("div", null, _toDisplayString(props.lge.swapFeePercentage) + "%", 1)
        ]),
        _hoisted_31
      ]),
      _createElementVNode("div", _hoisted_32, [
        (_unref(launchToken))
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(props.lge.tokenAmount), 1),
                _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(launchToken).symbol), 1),
                _createVNode(BalAsset, {
                  address: _unref(launchToken).address,
                  iconURI: props.lge.tokenIconUrl
                }, null, 8, ["address", "iconURI"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(collateralToken))
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(props.lge.collateralAmount), 1),
                _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(collateralToken).symbol), 1),
                _createVNode(BalAsset, {
                  address: _unref(collateralToken).address
                }, null, 8, ["address"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_43, [
        (_unref(launchToken))
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("span", _hoisted_47, _toDisplayString(props.lge.tokenStartWeight) + "%", 1),
                _createVNode(BalAsset, {
                  address: _unref(launchToken).address,
                  iconURI: props.lge.tokenIconUrl
                }, null, 8, ["address", "iconURI"]),
                _hoisted_48,
                _createElementVNode("span", _hoisted_49, _toDisplayString(props.lge.collateralStartWeight) + "%", 1),
                _createVNode(BalAsset, {
                  address: _unref(collateralToken).address
                }, null, 8, ["address"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(collateralToken))
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("span", _hoisted_53, _toDisplayString(props.lge.tokenEndWeight) + "%", 1),
                _createVNode(BalAsset, {
                  address: _unref(launchToken).address,
                  iconURI: props.lge.tokenIconUrl
                }, null, 8, ["address", "iconURI"]),
                _hoisted_54,
                _createElementVNode("span", _hoisted_55, _toDisplayString(props.lge.collateralEndWeight) + "%", 1),
                _createVNode(BalAsset, {
                  address: _unref(collateralToken).address
                }, null, 8, ["address"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_56, [
        (_unref(launchToken))
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(fNum)(_unref(poolLaunchToken)?.weight || '0', 'percent_lg')), 1),
                _createVNode(BalAsset, {
                  address: _unref(launchToken).address,
                  iconURI: props.lge.tokenIconUrl
                }, null, 8, ["address", "iconURI"]),
                _hoisted_61,
                _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(fNum)(_unref(poolCollateralToken)?.weight || '0', 'percent_lg')), 1),
                _createVNode(BalAsset, {
                  address: _unref(collateralToken).address
                }, null, 8, ["address"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_63,
          _createElementVNode("div", null, _toDisplayString(_unref(fNum)(props.pool.totalLiquidity, 'usd_lg')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", null, [
          _hoisted_65,
          _createElementVNode("div", null, _toDisplayString(_unref(fNum)(props.pool.totalSwapVolume, 'usd_lg')), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_66,
          _createElementVNode("div", null, _toDisplayString(_unref(fNum)(_unref(fundsRaised), 'usd')), 1)
        ])
      ])
    ])
  ], 64))
}
}

})